import { Injectable, InjectionToken } from '@angular/core';
export class ImageViewerConfig {
  width?: number;
  height?: number;
  bgStyle?: string;
  scaleStep?: number;
  rotateStepper?: boolean;
  showPaginator?: boolean;
  loadingMessage?: string;
  loadingErrorMessage?: string;
  messageStyle?: MessageStyle;
  buttonStyle?: ButtonStyle;
  tooltips?: {
    enabled?: boolean,
    bgStyle?: string,
    bgAlpha?: number,
    textStyle?: string,
    textAlpha?: number,
    padding?: number,
    radius?: number
  };
  nextPageButton?: ButtonConfig;
  beforePageButton?: ButtonConfig;
  zoomOutButton?: ButtonConfig;
  zoomInButton?: ButtonConfig;
  rotateLeftButton?: ButtonConfig;
  rotateRightButton?: ButtonConfig;
  resetButton?: ButtonConfig;
}

function ImageViewerConfig_tsickle_Closure_declarations() {
/** @type {?} */
ImageViewerConfig.prototype.width;
/** @type {?} */
ImageViewerConfig.prototype.height;
/** @type {?} */
ImageViewerConfig.prototype.bgStyle;
/** @type {?} */
ImageViewerConfig.prototype.scaleStep;
/** @type {?} */
ImageViewerConfig.prototype.rotateStepper;
/** @type {?} */
ImageViewerConfig.prototype.showPaginator;
/** @type {?} */
ImageViewerConfig.prototype.loadingMessage;
/** @type {?} */
ImageViewerConfig.prototype.loadingErrorMessage;
/** @type {?} */
ImageViewerConfig.prototype.messageStyle;
/** @type {?} */
ImageViewerConfig.prototype.buttonStyle;
/** @type {?} */
ImageViewerConfig.prototype.tooltips;
/** @type {?} */
ImageViewerConfig.prototype.nextPageButton;
/** @type {?} */
ImageViewerConfig.prototype.beforePageButton;
/** @type {?} */
ImageViewerConfig.prototype.zoomOutButton;
/** @type {?} */
ImageViewerConfig.prototype.zoomInButton;
/** @type {?} */
ImageViewerConfig.prototype.rotateLeftButton;
/** @type {?} */
ImageViewerConfig.prototype.rotateRightButton;
/** @type {?} */
ImageViewerConfig.prototype.resetButton;
}


export interface MessageStyle {
  color?: string;
  errorColor?: string;
  fontFamily?: string;
  fontSize?: number;
}

export interface ButtonStyle {
  iconFontFamily?: string;
  alpha?: number;
  hoverAlpha?: number;
  bgStyle?: string;
  iconStyle?: string;
  borderStyle?: string;
  borderWidth?: number;
}

export interface ButtonConfig {
  icon?: string;
  tooltip?: string;
  sortId?: number;
  show?: boolean;
}
/**
 * @param {?=} icon
 * @param {?=} tooltip
 * @param {?=} sortId
 * @param {?=} show
 * @return {?}
 */
export function createButtonConfig(icon?: string, tooltip?: string, sortId: number = 0, show: boolean = true) {
  return { icon: icon, tooltip: tooltip, sortId: sortId, show: show };
}

export const /** @type {?} */ IMAGEVIEWER_CONFIG = new InjectionToken<ImageViewerConfig>('imageviewer.config');

export let /** @type {?} */ IMAGEVIEWER_CONFIG_DEFAULT: ImageViewerConfig = {
  width: 800, // component default width
  height: 600, // component default height
  bgStyle: '#ECEFF1', // component background style
  scaleStep: 0.1, // zoom scale step (using the zoom in/out buttons)
  rotateStepper: false,
  showPaginator: true,
  loadingMessage: 'Loading...',
  loadingErrorMessage: 'Whoops, something bad happend.',
  messageStyle: {
    color: '#333',
    errorColor: 'red',
    fontSize: 25,
    fontFamily: 'Verdana, Geneva, sans-serif', // fonts for text messages
  },
  buttonStyle: {
    iconFontFamily: 'Material Icons', // font used to render the button icons
    alpha: 0.5, // buttons' transparence value
    hoverAlpha: 0.7, // buttons' transparence value when mouse is over
    bgStyle: '#000000', //  buttons' background style
    iconStyle: '#ffffff', // buttons' icon colors
    borderStyle: '#000000', // buttons' border style
    borderWidth: 0 // buttons' border width (0 == disabled)
  },
  tooltips: {
    enabled: true, // enable or disable tooltips for buttons
    bgStyle: '#000000', // tooltip background style
    bgAlpha: 0.5, // tooltip background transparence
    textStyle: '#ffffff', // tooltip's text style
    textAlpha: 0.9, // tooltip's text transparence
    padding: 15, // tooltip padding
    radius: 20 // tooltip border radius
  },
  nextPageButton: createButtonConfig(String.fromCharCode(0xE409), 'Next page', 0),
  beforePageButton: createButtonConfig(String.fromCharCode(0xE408), 'Previous page', 1),
  zoomOutButton: createButtonConfig(String.fromCharCode(0xE900), 'Zoom out', 0),
  zoomInButton: createButtonConfig(String.fromCharCode(0xE8FF), 'Zoom in', 1),
  rotateLeftButton: createButtonConfig(String.fromCharCode(0xE419), 'Rotate left', 2),
  rotateRightButton: createButtonConfig(String.fromCharCode(0xE41A), 'Rotate right', 3),
  resetButton: createButtonConfig(String.fromCharCode(0xE863), 'Reset', 4)
};
